import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: ${props => props.orientation};
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => props.theme.spacing.sp16};

  ${props =>
    props.clickable &&
    css`
      cursor: pointer;
      &:hover {
        filter: brightness(0.95);
      }
    `}
`

export const IconAndLabelContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.backgroundIcon};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => props.theme.spacing.sp4};
`
